<template>
  <div class="container pt100 faqs">
    <h2 class="text-center mb-10">
      <b>Shared web hosting</b>: Frequently Asked Questions (FAQ)
    </h2>
    <p class="text-center text-content-grey mb-40">
      Find answers to some frequently asked questions about hosting:
    </p>
    <div
      class="panel-group faq-block"
      id="accordion"
      role="tablist"
      aria-multiselectable="false"
    >
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingZero">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseZero"
            aria-expanded="false"
            aria-controls="collapseZero"
          >
            <h3 class="text-light-black">What is web hosting?</h3>
          </div>
        </div>
        <div
          id="collapseZero"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingZero"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Every website that you visit consists of a domain name and a web
              host. The easiest way to picture it is to think of the domain name
              as the address and the hosting as the physical building.
            </p>
            <p class="fs-14">
              When you’re browsing the web and you type in a URL (i.e.
              http://cryo.host), your web browser basically queries that domain
              name (i.e. cryo.host) and asks it where the website is hosted. The
              browser then loads up the contents that are stored there.
            </p>
            <p class="fs-14">
              Hosting is effectively the process of using a server to host a
              website, and there are all sorts of different types of hosting
              available out there on the market. CryoHost, just like most web
              hosts offers different packages so that their customers can pay
              for just the resources that they need. The more popular the
              website is, the more resources it’s likely to need to function
              effectively.
            </p>
            <p class="fs-14">
              The good news is that with CryoHost, you can scale your hosting
              package as and when you need it, so you can start off with Single
              hosting plan and gradually upgrade to Business or even VPS plan
              later.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingOne">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseOne"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            <h3 class="text-light-black">How does hosting work?</h3>
          </div>
        </div>
        <div
          id="collapseOne"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingOne"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Your website is basically a collection of files and (in most
              cases) database that are served up to your visitors as they browse
              around it. CryoHost will allocate space for you to store your
              website and database.
            </p>
            <p class="fs-14">
              When you sign up CryoHost, you’ll receive login details to access
              your hosting account’s admin panel.
            </p>
            <p class="fs-14">
              At CryoHost, we offer custom built hosting control panel. Using
              our control panel you can carry out basic hosting management,
              monitor resource usage, create email addresses and install content
              management systems (CMSs) like WordPress. Note that this is
              different to the admin panel for your website, which will be
              created when you install a CMS. This is the admin panel for your
              server as a whole.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingTwo">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            <h3 class="text-light-black">
              Are there different types of hosting services?
            </h3>
          </div>
        </div>
        <div
          id="collapseTwo"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingTwo"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Yes! Hosting comes in all different shapes and sizes, with
              different setups suitable for different types of a webmaster. In
              general, hosting can be broken up into the following categories:
            </p>
            <p class="fs-14">
              <b>Shared Hosting:</b> This is usually the cheapest form of
              hosting because it’s the most economical when it comes to the use
              of hardware. Shared hosting means that multiple different websites
              are all hosted on the same server, with each user being allocated
              a certain amount of storage space and a certain amount of
              resources. This is often the best option for hobbyists and
              bloggers.
            </p>
            <p class="fs-14">
              <b>VPS Hosting:</b> A virtual private server (VPS) setup is like a
              shared hosting setup on steroids. It generally uses more powerful
              hardware and takes its name from the fact that while multiple
              websites are being stored on the same physical hardware, each uses
              virtualisation software to allow them to operate independently as
              though they were dedicated mini-servers.
            </p>
            <p class="fs-14">
              <b>Dedicated Hosting:</b> Dedicated hosting is a good choice for
              the pros, and like its name suggests, it involves the use of a
              server that’s dedicated to a single website. In other words,
              unlike shared and VPS hosting, the user doesn’t have to share
              storage space and resources with other people and they have a
              physical piece of hardware all to themselves.
            </p>
            <p class="fs-14">
              <b>Cloud Hosting:</b> Cloud hosting allows webmasters to tap into
              a large bank of servers that are all interlinked and designed to
              take over from each other if needed. In other words, if you need
              more resources, the cloud will provide more resources to rise to
              the demand. Cloud hosting is usually the best option if you want
              to aim for 100% uptime and don’t care how much you need to pay for
              it.
            </p>
            <p class="fs-14">
              CryoHost provides a mix of shared and vps hosting. This setup
              allows us to provide fast hosting with nearly 100% uptime at an
              unbeatable price.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingThree">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            <h3 class="text-light-black">
              Do I need to have technical knowledge to use CryoHost hosting?
            </h3>
          </div>
        </div>
        <div
          id="collapseThree"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingThree"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Not at all! CryoHost makes it as easy as possible for novice users
              to pick up the basics as they go along. Many of the everyday
              tasks, such as setting up an email address or installing a content
              management system (CMS), can be done with just a few clicks and
              with no technical knowledge whatsoever.
            </p>
            <p class="fs-14">
              However, don’t let that fool you - while it’s easy to pick up the
              basics and get going, our hosting packages are also suitable for
              experienced developers. After all, there’s no reason why something
              can’t be both user-friendly and powerful at the same time.
            </p>
            <p class="fs-14">
              If you’re struggling, there’s no shortage of online guides to walk
              you through the most common tasks that you might want to carry
              out, and we also have a customer support team who’ll be more than
              happy to help if you get stuck. But for the majority of our
              customers, no help is needed - and if you just want to jump in and
              get started, it’s quicker and easier than signing up for a new
              social network.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingFour">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            <h3 class="text-light-black">
              What are the main differences between shared hosting and a VPS?
            </h3>
          </div>
        </div>
        <div
          id="collapseFour"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingFour"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Good question! A virtual private server (VPS) is a little bit like
              a cross between shared hosting and a dedicated server. It’s not
              quite the best of both worlds, but it is a good compromise and it
              can help you to keep costs down. Some people compare shared
              hosting to living in an apartment complex and VPS hosting to
              living in a condo.
            </p>
            <p class="fs-14">
              With shared hosting, you’re sharing a server and that server’s
              resources with a bunch of other websites. With a VPS, you’re still
              sharing some resources because that’s determined by the hardware,
              but the software itself is set up in such a way that one machine
              acts like multiple different servers, providing a different
              virtual server for every user.
            </p>
            <p class="fs-14">
              For webmasters, using a VPS means that they get the administrative
              power of a dedicated hosting setup, including the ability to
              customize their server to suit them.
            </p>
            <p class="fs-14">
              If you think VPS will be more suitable for you check out our
              <router-link to="/hosting/vps"
                >cheap VPS hosting plans here
              </router-link>
              .
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingFive">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseFive"
            aria-expanded="false"
            aria-controls="collapseFive"
          >
            <h3 class="text-light-black">
              How long does it take to set up a CryoHost hosting account?
            </h3>
          </div>
        </div>
        <div
          id="collapseFive"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingFive"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Not long at all! We’re proud of the fact that setup is instant.
              That means our new customers can get started straight away without
              delay. Just create your account and walk through the setup process
              and you’ll be ready to log in and to start managing your new
              hosting account immediately.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingSix">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseSix"
            aria-expanded="false"
            aria-controls="collapseSix"
          >
            <h3 class="text-light-black">What kind of hosting do I need?</h3>
          </div>
        </div>
        <div
          id="collapseSix"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingSix"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              That depends - what kind of website do you have? And what’s your
              budget?
            </p>
            <p class="fs-14">
              As a general rule, shared hosting is the best place to start, and
              CryoHost’s hosting is suitable for almost any kind of website. Our
              hosting helps you to keep the costs down during the early days of
              your website while allowing you to pay only for the resources that
              you need. If your website starts to take off, you can easily
              upgrade to higher tier plan and pick up some extra resources.
            </p>
            <p class="fs-14">
              Ultimately, every website is different. If you’re not sure, why
              not get in touch with our team so we can chat it through with you
              and make a personalized suggestion based on your needs?
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingSeven">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseSeven"
            aria-expanded="false"
            aria-controls="collapseSeven"
          >
            <h3 class="text-light-black">What’s hosting bandwidth?</h3>
          </div>
        </div>
        <div
          id="collapseSeven"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingSeven"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              You might already be familiar with the term ‘bandwidth’ from your
              broadband provider. At its most simple level, bandwidth is a term
              that refers to how much data can pass along an internet
              connection.
            </p>
            <p class="fs-14">
              When a user accesses your website, they send a request to the
              server and the server responds by literally serving up your
              website. Think of it as like turning on a tap. The more that
              people visit your website, the more water is flowing along the
              pipe, until you reach a point at which the pipe is full of water
              and it’s running at full capacity.
            </p>
            <p class="fs-14">
              The same idea applies to your website. If too many people are
              trying to access it at the same time, the pipe is filled up and
              the site starts to slow down and even to stop working altogether.
              And your hosting bandwidth is what determines the width of that
              pipe.
            </p>
            <p class="fs-14">
              While other hosting providers are limiting bandwidth,
              <b>CryoHost offers truly unlimited bandwidth</b> with all our
              hosting plans
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingEight">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseEight"
            aria-expanded="false"
            aria-controls="collapseEight"
          >
            <h3 class="text-light-black">What’s a MySQL Database?</h3>
          </div>
        </div>
        <div
          id="collapseEight"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingEight"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              MySQL is an open source database management system that uses
              structured query language (SQL) to access, add to and manage the
              content of a database. The fact that it’s an open source tool
              means that it’s a popular choice for software developers, which is
              why it forms the backbone of many of the most popular operating
              systems.
            </p>
            <p class="fs-14">
              Most modern content management system (such as WordPress) use it
              to store data. Every change that you make in the CMS is recorded
              in the MySQL database, and then every time a visitor arrives on
              the site, the content of that database is served up to them.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingNine">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseNine"
            aria-expanded="false"
            aria-controls="collapseNine"
          >
            <h3 class="text-light-black">What’s an SSL certificate?</h3>
          </div>
        </div>
        <div
          id="collapseNine"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingNine"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              An SSL certificate is a small data file that uses a cryptographic
              key to digitally tie your company’s identity with the files that
              are stored on your webserver. The idea is to prove the identity of
              the publisher of a webpage and to reduce the likelihood of a
              visitor accessing sensitive areas of a website without the
              appropriate security.
            </p>
            <p class="fs-14">
              When a website has been secured with an SSL certificate, a visitor
              will see a padlock icon in their web browser and they’ll be
              connected to the site using the https:// protocol. With the SSL
              certificate in place and the user accessing the site through
              https, the connection between the browser and the web server has
              been secured and sensitive information can safely be transferred.
            </p>
            <p class="fs-14">
              That’s why people use SSL certificates on e-commerce websites and
              other types of website that process credit card transactions and
              other financial information.
            </p>
            <p class="fs-14">
              We offer free SSL certificates with Business hosting plans.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingTen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseTen"
            aria-expanded="false"
            aria-controls="collapseTen"
          >
            <h3 class="text-light-black">How can I build a website?</h3>
          </div>
        </div>
        <div
          id="collapseTen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingTen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              There are plenty of different ways to build a website, and it’s
              our goal to make it as easy as possible for you to do that. We
              want you to be able to sign up and start building your website
              straight away with no delay, which is why we’ve put a lot of time
              into streamlining it all.
            </p>
            <p class="fs-14">
              If you just want to get started, the best option is usually to use
              our auto installer to install a content management system (CMS)
              which you can customize to suit your needs, whether you’re setting
              up a blog or whether you’re creating a website for your business.
              With a CMS, you can create new pages and customize the look and
              feel of your site without any technical know-how or programming
              ability.
            </p>
            <p class="fs-14">
              Many webmasters use WordPress which is the most widely-used CMS in
              the world. All our hosting plans are fully optimized for
              WordPress.
            </p>
            <!--                                <p class="fs-14">But if WordPress doesn’t take your fancy, don’t worry. We also offer an-->
            <!--                                    intuitive drag and drop website builder that’s designed to get your site live in-->
            <!--                                    five minutes with no coding and no technical knowledge needed. You can find out more-->
            <!--                                    about that <a href="/website-builder">right here</a>.</p>-->
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingEleven">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseEleven"
            aria-expanded="false"
            aria-controls="collapseEleven"
          >
            <h3 class="text-light-black">Will I get a free domain name?</h3>
          </div>
        </div>
        <div
          id="collapseEleven"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingEleven"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Yes! We make it easy for you to get going by offering a free
              domain name when you sign up for an annual plan. We also offer
              some of the lowest prices on the market so that you can set up
              your website without spending a small fortune.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingTwelve">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseTwelve"
            aria-expanded="false"
            aria-controls="collapseTwelve"
          >
            <h3 class="text-light-black">
              Can I transfer my website to CryoHost?
            </h3>
          </div>
        </div>
        <div
          id="collapseTwelve"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingTwelve"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Yes - and we actively encourage it! If you’re using one of the
              more common CMS platforms such as WordPress then there are plenty
              of tools available to make it easy to export from one host and to
              import into another. But if you’re not using a common CMS - or if
              you need a little help along the way - then just let us know. Our
              staff will do everything they can to help you to make the transfer
              - and we’ll do it free of charge!!
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingThirteen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseThirteen"
            aria-expanded="false"
            aria-controls="collapseThirteen"
          >
            <h3 class="text-light-black">
              Will CryoHost help me to create my website?
            </h3>
          </div>
        </div>
        <div
          id="collapseThirteen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingThirteen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">Well that depends!</p>
            <p class="fs-14">
              We’ll certainly do everything we can to lend a helping hand,
              whether that’s by pointing you in the right direction or by
              troubleshooting errors and issues. We also have a large knowledge
              base that’s filled with answers to existing questions, as well as
              a range of tutorials which were written with new customers in mind
              to help them to get started and to make the most of their CryoHost
              plan.
            </p>
            <p class="fs-14">
              That said, we’re hosting specialists - which means that while
              we’ll offer as much help and support as we can, we’re not able to
              build you a website from scratch. But don’t worry about it -
              thanks to our website builder and our auto installers, you won’t
              have a problem.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingFourteen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseFourteen"
            aria-expanded="false"
            aria-controls="collapseThirteen"
          >
            <h3 class="text-light-black">
              Can I buy Hosting without a domain name?
            </h3>
          </div>
        </div>
        <div
          id="collapseFourteen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingFourteen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Yes, you can. If you want to, you can purchase domain names from
              elsewhere and point it to your server with CryoHost. If you want
              to keep your domain name and your website hosting together under a
              single provider — which we’d recommend for convenience and easier
              troubleshooting — then you can also transfer an existing domain
              name to CryoHost. Just get in touch and let us know!
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingFifteen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseFifteen"
            aria-expanded="false"
            aria-controls="collapseFifteen"
          >
            <h3 class="text-light-black">
              Can I upgrade my hosting plan as my website grows?
            </h3>
          </div>
        </div>
        <div
          id="collapseFifteen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingFifteen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Yes! In fact, this is usually what we recommend, and it’s one of
              the benefits of choosing CryoHost as your hosting provider. We
              make the upgrade procedure as simple as possible so that you can
              start on our budget plans and upgrade as your website starts to
              take off. We’re there alongside you at all times and we’re ready
              to grow with you!
            </p>
            <p class="fs-14">
              Many other hosting providers will try to talk you into taking out
              plans that you neither need nor want. We disagree with that. We
              believe you should pay only for the resources that you need.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingSixteen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseSixteen"
            aria-expanded="false"
            aria-controls="collapseSixteen"
          >
            <h3 class="text-light-black">
              How can I be sure CryoHost hosting is secure?
            </h3>
          </div>
        </div>
        <div
          id="collapseSixteen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingSixteen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              We take security very seriously because there’s no point having a
              website if you can’t be sure that it’s safe from attack. We use
              Voxility to protect all of our users, and we go out of our way to
              ensure that our servers are as strong and secure as possible. This
              includes running advanced, custom-built security software and
              regularly updating our infrastructure.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingSeventeen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseSeventeen"
            aria-expanded="false"
            aria-controls="collapseSeventeen"
          >
            <h3 class="text-light-black">
              Can I install and run an ecommerce site on CryoHost hosting?
            </h3>
          </div>
        </div>
        <div
          id="collapseSeventeen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingSeventeen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Of course! We’re all about helping our customers to get their
              businesses off the ground, and that means that we support
              e-commerce sites on any of our plans. You can also take advantage
              of our auto-installers to set up a range of content management
              systems (CMS) and e-commerce platforms.
            </p>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingEighteen">
          <div
            class="faq-button collapsed"
            role="button"
            data-toggle="collapse"
            data-parent="#accordion"
            href="#collapseEighteen"
            aria-expanded="false"
            aria-controls="collapseEighteen"
          >
            <h3 class="text-light-black">What kind of support will I get?</h3>
          </div>
        </div>
        <div
          id="collapseEighteen"
          class="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="headingEighteen"
          style=""
        >
          <div class="panel-body text-content-grey">
            <p class="fs-14">
              Here at CryoHost, we pride ourselves on our support team. In fact,
              we call our support team our customer success team, because we go
              the extra mile to make sure that our customers are as successful
              as possible. If you have a problem, no matter what it is, then get
              in touch with us. We’ll do our best to fix it if it’s something
              that’s under control, and even if not, we’ll try to point you in
              the right direction.
            </p>
            <p class="fs-14">
              Our customer success team is top-rated within the industry and we
              have a long track record of doing everything in our power to help
              our customers. We respond quickly and thoroughly and don’t give up
              until we’ve found a solution. So if you’re having a problem, get
              in touch!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        name: "FrequentlyAskedQuestionsComponent"
    }
</script>